import type { ShowMoreProps as RBCShowMoreProps } from 'react-big-calendar'
import React from 'react'
import { makeStyles, Typography } from '@paintscout/ui'
import type { CalendarEvent } from 'paintscout'
import classnames from 'classnames'

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(11),
    marginLeft: theme.spacing(1),
    zIndex: 1000,
    position: 'relative',
    backgroundColor: 'transparent'
  }
}))

interface ShowMoreProps extends RBCShowMoreProps<CalendarEvent> {
  onClick: (date: Date) => void
}

export default function ShowMore(props: ShowMoreProps) {
  const { count, onClick, slotDate } = props
  const classes = useStyles()

  return (
    <Typography
      variant="subtitle2"
      color="textPrimary"
      className={classnames(classes.root, 'rbc-button-link rbc-show-more')}
      component="div"
      onClick={() => onClick(slotDate)}
    >
      {count} more...
    </Typography>
  )
}
